import { baseApi } from "api/BaseApi";

interface TriggerPcmPostedPayload {
  rid: number;
  postingAdvice?: string;
}

interface TriggerPcmRejectedPayload {
  rid: number;
  rejectionReason: string;
}

const pcmNotificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    triggerNotifyPcmPosted: build.mutation<void, TriggerPcmPostedPayload>({
      query: (body) => ({
        url: "v2/notifications/pcm-posted/",
        method: "POST",
        body,
      }),
    }),
    triggerNotifyPcmRejected: build.mutation<void, TriggerPcmRejectedPayload>({
      query: (body) => ({
        url: "v2/notifications/pcm-rejected/",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useTriggerNotifyPcmPostedMutation,
  useTriggerNotifyPcmRejectedMutation,
} = pcmNotificationsApi;
